import { AuthenticationResult, InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { useAccount } from "@azure/msal-react";
// eslint-disable-next-line import/no-unresolved
import formbricks from "@formbricks/js";
import { getCookie } from "../../helper/handleCookies/handleCookies";
import { loginRequest, msalInstance } from "../config/authConfig";
import Role from "../permissions/Role";

export const useUserName = () => {
  const account = useAccount();

  return account?.name || "";
};

const getRedirectUrl = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://connect.cooperation.flixbus.com/";
  }
  if (process.env.NODE_ENV === "staging") {
    return "https://connect.cooperation-dev.flixbus.com/";
  }

  return "http://localhost:1111/";
};

export const logout = () => {
  const redirectUrl = getRedirectUrl();

  formbricks.logout();
  window.localStorage.clear();
  msalInstance.logoutRedirect({
    postLogoutRedirectUri: redirectUrl,
  });
};

export const buildAuthorizationHeader = (token: string) => {
  return {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
};
export const AUTH_ISSUER_CYPRESS_COOKIE_NAME = "auth-issuer-cypress";

export const isUnitTest = () => process.env.NODE_ENV === "test";

export const isTestEnv = () => {
  const cookieValue = getCookie(AUTH_ISSUER_CYPRESS_COOKIE_NAME);

  if (process.env.NODE_ENV !== "production") {
    if (cookieValue || isUnitTest()) {
      return true;
    }
    return false;
  }
  return false;
};

export const isExpired = (exp: number | undefined): boolean => {
  return typeof exp !== "number" || exp * 1000 < Date.now();
};

export const getToken = async (
  inProgess: InteractionStatus = InteractionStatus.None,
  forceRefresh = false
): Promise<void | AuthenticationResult | undefined> => {
  if (!forceRefresh) {
    // First, handle any pending redirect response
    const redirectResponse = await msalInstance.handleRedirectPromise();
    if (redirectResponse) {
      // If there's a redirect response, return the token, it is now in the msal cache
      return redirectResponse;
    }
  }

  return msalInstance
    .acquireTokenSilent({
      ...loginRequest(),
      forceRefresh,
    })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      // WE don't want that error to be spamming when we test the error case in jest
      if (!isTestEnv()) {
        console.warn(`acquireTokenSilent failed: ${error}`);
      }

      if (error instanceof InteractionRequiredAuthError) {
        // fallback to interaction when silent call fails
        if (inProgess === InteractionStatus.None) {
          return msalInstance
            .acquireTokenRedirect({
              ...loginRequest(),
            })
            .catch((err) => {
              if (!isTestEnv()) {
                console.error(`acquireTokenRedirect failed: ${err}`);
              }
            });
        } else {
          console.error("Interaction already in Progress");
        }
      }

      return undefined;
    });
};

export const getRoles = (): Role[] | undefined => msalInstance.getActiveAccount()?.idTokenClaims?.roles as Array<Role>;
